import { render } from "./Compania.vue?vue&type=template&id=5f1d9124"
import script from "./Compania.vue?vue&type=script&lang=js"
export * from "./Compania.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__